'use strict';

/**
 * @ngdoc service
 * @name prepApp.routeNavigation
 * @description
 * # routeNavigation
 * Factory in the prepApp.
 */
angular.module('prepApp')
    .factory('routeNavigation', function ($route, $location) {
        var routes = [];
        angular.forEach($route.routes, function (route, path) {
            if (route.name) {
                routes.push({
                    path: path.substring(1),
                    name: route.name
                });
            }
        });
        return {
            routes: routes,
            activeRoute: function (route) {
                return route.path === $location.path().substring(1) || '';
            }
        };
    });
